<template>
    <div>
        <div class="left">
            <Left></Left>
        </div>
        <div class="right">
            <Right></Right>
        </div>
    </div>
</template>
<script>
    import Left from "./detail_left"
    import Right from "./detail_right"
    export default {
        name:"index",
        components:{
            Left,
            Right
        }
    }
</script>
<style scoped>
    .left{
        float: left;
        background: #ffffff;
        width:66%;
        min-height: 500px;
    }
    .right{
        float:left;
        margin-left:20px;
        width:32%;
        background: #ffffff;
    }
</style>
